import React from 'react';

import { DisplayComponent } from 'formlabs-web-components/BaseComponents';

import List from './List';

const SubCollectionListPlugin = DisplayComponent(({ resources }) => (
  <List resources={resources} />
));

export default SubCollectionListPlugin;
